<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12 vh-header d-flex flex-column pr-0">
        <div class="card flex-1-auto h-100 overflow-auto">
            <div class="card-header card-header-with-button">
               <h5>{{$t('JOB')}}</h5>
               <button type="button" v-if="(globals && globals.acl && globals.acl.Job && globals.acl.Job.insertAction)" class="btn-bis btn-primary" @click="showModal()">{{$t('NEW')}}</button>
            </div>
            <div class="card-body" v-if="globals && globals.groupId != 8">
              <div class="row">
                <div class="col-12">
                  <div class="flex-0-auto mb-3">
                    <div class="buttons-group">
                      <label class="has-float-label mr-2" v-if="globals.groupId === 1 || globals.globals === 5">
                          <b-form-fieldset v-bind:label="$t('USERCOMPANIES')">
                              <lbselect 
                                :empty="true" 
                                :list="companyData.root" 
                                :total-count="companyData.totalCount"
                                :pagination="paginationCompany"
                                v-on:reload="getCompanyData()"
                                v-model="paginationSec.companyId" 
                                value-field="companyId" 
                                display-field="companyName">
                              </lbselect>
                          </b-form-fieldset>
                      </label>

                      <label class="has-float-label mr-2" v-if="(globals && globals.acl && globals.acl.UserSubCompanies && globals.acl.UserSubCompanies.insertAction)">
                          <b-form-fieldset v-bind:label="$t('USERSUBCOMPANIES')">
                              <lbselect 
                                  :empty="true" 
                                  :list="subCompanyData.root" 
                                  :total-count="subCompanyData.totalCount"
                                  :pagination="paginationSubCompany"
                                  v-on:reload="getSubCompanyData()"
                                  v-model="paginationSec.subCompanyId" 
                                  value-field="subCompanyId" 
                                  display-field="subCompanyName">
                              </lbselect>
                          </b-form-fieldset>
                      </label>

                      <label class="has-float-label mr-2" v-if="(globals && globals.acl && globals.acl.BuildingDetail && globals.acl.BuildingDetail.insertAction)">
                          <b-form-fieldset v-bind:label="$t('CLIENT')">
                              <lbselect 
                                :empty="true" 
                                :list="building.root" 
                                :total-count="building.totalCount"
                                :pagination="paginationBuilding"
                                v-on:reload="getBuildingData()"
                                v-model="paginationSec.client" 
                                value-field="buildingDetailId" 
                                display-field="clientName">
                              </lbselect>
                          </b-form-fieldset>
                      </label>
                      <label class="has-float-label mr-2">
                          <b-form-fieldset>
                              <span>{{$t('ADDRESS')}}</span>
                              <input class="form-control" placeholder=" " v-model="paginationSec.address">
                          </b-form-fieldset>
                      </label>
                      <label class="has-float-label mr-2">
                          <b-form-fieldset>
                              <span>{{$t('COMPANYWORKER')}}</span>
                              <input class="form-control" placeholder=" " v-model="paginationSec.companyWorker">
                          </b-form-fieldset>
                      </label>
                      <label class="has-float-label mr-2">
                        <b-form-fieldset v-bind:label="$t('STARTDATE')">
                            <datetimepicker
                                type="date"
                                v-model="paginationSec.date"
                                format="YYYY-MM-DD"
                                display-format="DD.MM.YYYY."
                                placeholder=" "
                                :isClearable="true"
                                :showSeconds="false"
                                :isUTC="false"
                                :simple="true"
                                class="form-control"
                                :translate-method="trans">
                            </datetimepicker>
                        </b-form-fieldset>
                      </label>
                      <label class="has-float-label mr-2" v-if="paginationSec.date">
                        <b-form-fieldset v-bind:label="$t('ENDDATE')">
                            <datetimepicker
                                type="date"
                                v-model="paginationSec.dateTo"
                                format="YYYY-MM-DD"
                                display-format="DD.MM.YYYY."
                                placeholder=" "
                                :isClearable="true"
                                :showSeconds="false"
                                :isUTC="false"
                                :simple="true"
                                class="form-control"
                                :translate-method="trans">
                            </datetimepicker>
                        </b-form-fieldset>
                      </label>
                      <label class="has-float-label mr-2">
                        <b-form-fieldset v-bind:label="$t('STATUS')">
                            <b-form-select :class="`form-control select-${paginationSec.status}`" v-model="paginationSec.status">
                                <b-form-select-option 
                                    v-for="item in status" 
                                    :key="item.value" 
                                    :value="item.value"
                                    :class="`select-${item.value}`">
                                    {{ item.text.toUpperCase() }}
                                </b-form-select-option>
                            </b-form-select>
                        </b-form-fieldset>
                      </label>
                      </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body" v-if="data.root == null || !data.root.length">
              <p class="center">{{$t('NODATAFOUND')}}</p>
            </div>
            <div class="table-responsive h-100 flex-1-auto mb-0" v-if="data.root != null && data.root.length">
              <table class="table table-bis">
                <thead>
                  <tr>
                    <th></th>
                    <th></th>
                    <th>{{$t('ID')}}</th>
                    <th>{{$t('JOBNUMBER')}}</th>
                    <th>{{$t('CLIENT')}}</th>
                    <th>{{$t('ADDRESS')}}</th>
                    <th>{{$t('CONTACTPERSON')}}</th>
                    <th>{{$t('PHONE')}}</th>
                    <th>{{$t('COMPANYWORKER')}}</th>
                    <th>{{$t('FLOW')}}</th>
                    <th>{{$t('DATE')}}</th>
                    <th>{{$t('STARTDATE')}}</th>
                    <th>{{$t('ENDDATE')}}</th>
                    <th>{{$t('ACTION')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="item in data.root">
                    <tr :key="item.jobId" aria-rowindex="1" :class="`table-ellipsis ${getItemStatusColor(item)}`">
                        <td>
                            <icon v-if="item.showAditionalData != null && item.showAditionalData == true" icon="arrow-up" @click="hideRow(item)"></icon>
                            <icon v-else icon="arrow-down" @click="showRow(item)"></icon>
                        </td>
                        <td>
                            <icon v-if="item.criticalAttention" icon="warning" style="color: #9c1c2b" :title="$t('CRITICALATTENTION')"></icon>
                            <icon v-if="item.status === 'partialyfinished'" icon="wrench" style="color: #2e5c31" :title="$t(item.status.toUpperCase())"></icon>
                        </td>
                        <td>{{item.jobId}}</td>
                        <td>{{item.jobNumber}}</td>
                        <td>{{item.client}}</td>
                        <td>{{item.address}}</td>
                        <td>{{item.contactPerson}}</td>
                        <td>{{item.phone}}</td>
                        <td>{{item.companyWorkerName}} {{item.companyWorkerSurname}}</td>
                        <td>{{item.flow}}</td>
                        <td>{{item.jobDate | formatDateTime("DD.MM.YYYY. HH:mm")}}</td>
                        <td>{{item.jobStartDate | formatDate}}</td>
                        <td>{{item.jobEndDate | formatDate}}</td>
                        <td class="table-buttons">
                          <b-button v-if="handleJobViewing(item)" type="reset" class="btn-table table-btn-primary"  @click="showAnswersModalCheck(item)">{{$t('HANDLEJOB')}}</b-button>
                          <b-button v-if="viewAnswersViewing(item)" type="reset" class="btn-table table-btn-primary ml-1" @click="viewAnswersModal(item)">{{$t('VIEWANSWERS')}}</b-button>
                          <b-button v-if="editViewing(item)" type="reset" class="btn-table table-btn-secondary ml-1"  @click="showModal(item)">{{$t('EDIT')}}</b-button>
                          <b-button v-if="assignViewing(item)" type="reset" class="btn-table table-btn-secondary ml-1"  @click="showModalAssign(item)">{{$t('ASSIGN')}}</b-button>
                          <b-button v-if="deleteViewing(item)" type="reset" class="btn-table table-btn-delete ml-1" @click="deleteRow(item.jobId)">{{$t('DELETE')}}</b-button>
                          <b-button v-if="declineViewing(item)" type="reset" class="btn-table table-btn-delete ml-1" @click="decline(item)">{{$t('DECLINE')}}</b-button>
                        </td>
                    </tr>
                    <tr :key="`${item.jobId}_thr`" v-if="item.showAditionalData != null && item.showAditionalData == true">
                       <td>{{$t('COMMENT')}}:</td>
                       <td colspan="9">{{item.comment}}</td> 
                    </tr>
                    <tr :key="`${item.jobId}_sec`" v-if="item.showAditionalData != null && item.showAditionalData == true">
                       <td>{{$t('DECLINEREASON')}}:</td>
                       <td colspan="9">{{item.decline}}</td> 
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <div class="table-navigation d-flex">
                <div class="status-legend flex-1 ml-2">
                    <div class="legend-item legend-pending">
                        <h5>{{$t('PENDING')}}</h5>
                    </div>
                    <div class="legend-item legend-open">
                        <h5>{{$t('ACTIVE')}}</h5>
                    </div>
                    <div class="legend-item legend-overdue">
                        <h5>{{$t('OVERDUE')}}</h5>
                    </div>
                    <div class="legend-item legend-finished">
                        <h5>{{$t('FINISHED')}}</h5>
                    </div>
                    <div class="legend-item legend-failed">
                        <h5>{{$t('CANCELED')}}</h5>
                    </div>
                    <div class="legend-item legend-decline">
                        <h5>{{$t('DECLINE')}}</h5>
                    </div>                  
                </div>

                <nav class="flex-0">
                    <b-pagination align="center" :total-rows="parseInt(data.totalCount)" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>
                </nav>

                <div class="pagination-right flex-1">
                    <p v-if="data != null && data.totalCount != null">{{$t('SHOWING')}} {{paginValues.start}} - {{paginValues.end}} {{$t('FROM')}} {{data.totalCount}}</p>
                </div>
              </div>
          </div>
        </div>
    </div>
    <jobform v-model="formData" v-on:close="formData = null; getData()"></jobform>
    <formassign v-model="formDataAssign" v-on:close="formDataAssign = null; getData()"></formassign>
    <declineform v-model="declineFormData" v-on:close="declineFormData = null; getData()"></declineform>
    <answerform v-model="formAnswers" v-on:close="formAnswers = null; getData()"></answerform>
    <viewansersform v-model="formViewAnswers" v-on:close="formViewAnswers = null; getData()"></viewansersform>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import moment from 'moment';
import Api from '@/api/job/Job.js';
import BuildingApi from '@/api/building_detail/BuildingDetail.js';
import CompanyApi from '@/api/admin/UserCompanies'
import SubCompanyApi from '@/api/admin/UserSubCompanies.js';
import JobForm from './Form.vue';
import FormAssign from './FormAssign.vue';
import DeclineForm from './DeclineForm.vue';
import AnswerForm from './AnswerForm.vue';
import ViewAnsersForm from './ViewAnsersForm.vue';
import localTranslate from '../../helpers/local_trans';


export default {
    name: 'Job',
    components:
    {
        jobform: JobForm,
        answerform: AnswerForm,
        viewansersform: ViewAnsersForm,
        declineform: DeclineForm,
        formassign: FormAssign,
    },
    data()
    {
        const me = this;

        return {
            loading: true,
            data: {},
            companyData: {},
            subCompanyData: {},
            building: {},
            formData: null,
            formDataAssign: null,
            declineFormData: null,
            formAnswers: null,
            formViewAnswers: null,
            paginationSec: {
                companyId: null,
                subCompanyId: null,
                client: null,
                address: null,
                companyWorker: null,
                date: null,
                dateTo: null,
                status: null,
            },
            status:
            [
                {
                value: null,
                text: me.$i18n.t('SHOWALL'),
                },
                {
                value: 'pending',
                text: me.$i18n.t('PENDING'),
                },
                {
                value: 'active',
                text: me.$i18n.t('ACTIVE'),
                },
                {
                value: 'overdue',
                text: me.$i18n.t('OVERDUE'),
                },
                {
                value: 'finished',
                text: me.$i18n.t('FINISHED'),
                },
                {
                value: 'partialyfinished',
                text: me.$i18n.t('PARTIALYFINISHED'),
                },
                {
                value: 'canceled',
                text: me.$i18n.t('CANCELED'),
                },
                {
                value: 'decline',
                text: me.$i18n.t('DECLINE'),
                },
                {
                value: 'criticalattention',
                text: me.$i18n.t('CRITICALATTENTION'),
                }
            ],
            pagination: {
                query: '',
                currentPage: 1,
                limit: 25,
            },
            paginationBuilding: {
                query: '',
                currentPage: 1,
                limit: 25,
            },
            paginationSubCompany: {
                query: '',
                currentPage: 1,
                limit: 25,
            },
            paginationCompany: {
                query: '',
                currentPage: 1,
                limit: 25,
            },
            searchTimeout: false,
        };
    },
    created()
    {
        const me = this;

        if (me.$route.query != null && Object.keys(me.$route.query).length > 0)
        {
            const query = me.$route.query;

            if (query.companyId) { me.paginationSec.companyId = query.companyId; }
            if (query.subCompanyId) { me.paginationSec.subCompanyId = query.subCompanyId; }
            if (query.buildingDetailId) { me.paginationSec.client = query.buildingDetailId; }
            if (query.address) { me.paginationSec.address = query.address; }
            if (query.status) { me.paginationSec.status = query.status; }
        }

        me.getCompanyData();
        me.getSubCompanyData();
        me.getBuildingData();
        me.getData();
    },
    methods:
  {
        trans(key)
        {
            const me = this;
            return localTranslate(me.globals.langId, key);
        },
        handleJobViewing(item)
        {
            let status = false;

            if (item.showFlowForm === 1)
            {
                status = true;
            }

            return status;
        },
        getItemStatusColor(item) {
            if (item.overdue) {
                return 'overdue';
            }
            return item.status;
        },
        viewAnswersViewing(item)
        {
            const me = this;
            let status = false;

            if (item.showAnswers === 1
                && me.globals.groupId != 8)
            {
                status = true;
            }

            return status;
        },
        editViewing(item)
        {
            const me = this;
            let status = false;

            if (me.globals
                && me.globals.acl
                && me.globals.acl.Job
                && me.globals.acl.Job.insertAction)
            {
                status = true;
            }

            return status;
        },
        assignViewing(item)
        {
            const me = this;
            let status = false;

            // check if user has assign privilages
            if (me.globals
                && me.globals.groupId != 8
                && me.globals.acl
                && me.globals.acl.Job
                && !me.globals.acl.Job.insertAction)
            {
                status = true;
            }

            // check if job status is correct
            if (!item.showFlowForm)
            {
                status = false;
            }

            return status;
        },
        deleteViewing(item)
        {
            const me = this;
            let status = false;

            if (me.globals
                && me.globals.acl
                && me.globals.acl.Job
                && me.globals.acl.Job.insertAction)
            {
                status = true;
            }

            return status;
        },
        declineViewing(item)
        {
            const me = this;
            let status = false;

            if (me.globals && (me.globals.groupId == 7 || me.globals.groupId == 8))
            {
                if (item && item.status !== 'finished' && item.status !== 'canceled' && item.status !== 'decline')
                {
                    status = true;
                }
            }

            return status;
        },
      hideRow(item)
      {
          const me = this;
          me.$set(item, 'showAditionalData', false);
      },
      showRow(item)
      {
          const me = this;
          me.$set(item, 'showAditionalData', true);
      },
      async getCompanyData()
      {
          const me = this;
          try
          {
              me.loading = true;
              const data = await CompanyApi.selectRow(me.getParamsCompany);
              if (data.error && data.error === true)
              {
                  throw (data);
              }
              me.companyData = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
          finally
          {
              me.loading = false;
          }
      },
      async getSubCompanyData()
      {
          const me = this;
          try
          {
              me.loading = true;
              const data = await SubCompanyApi.selectRow(me.getParamsSubCompany);
              if (data.error && data.error === true)
              {
                  throw (data);
              }
              me.subCompanyData = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
          finally
          {
              me.loading = false;
          }
      },
      async getBuildingData()
      {
          const me = this;
          try
          {
              me.loading = true;
              const data = await BuildingApi.selectRow(me.getParamsBuilding);
              if (data.error && data.error === true)
              {
                  throw (data);
              }
              me.building = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
          finally
          {
              me.loading = false;
          }
      },
      async getData()
      {
          const me = this;
          try
          {
              me.loading = true;
              const data = await Api.selectRow(me.getParams);
              if (data.error && data.error === true)
              {
                  throw (data);
              }
              me.data = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
          finally
          {
              me.loading = false;
          }
      },
      async deleteRow(id)
      {
          const me = this;
          me.$store.commit('setModalAlert',
              {
                  text: me.$i18n.t('AREYOUSHURE'),
                  async btnAction()
                  {
                      const data = await Api.deleteRow({ id });
                      me.$notify.notice(data);
                      me.getData();
                  },
              });
      },
      decline(item)
      {
            const me = this;
          if (typeof item == null)
          {
              item = {};
          }
          me.declineFormData = { ...item };
      },
      showModalAssign(item)
      {
          const me = this;
          if (typeof item == null)
          {
              item = {};
          }
          me.formDataAssign = { ...item };
      },
      showModal(item)
      {
          const me = this;
          if (typeof item == null)
          {
              item = {};
          }
          me.formData = { ...item };
      },
      showAnswersModalCheck(item)
      {
          const me = this;
          if (item.cntAnswers > 0 && item.overwrite === 1)
          {
              me.$store.commit('setModalAlert',
              {
                  text: me.$i18n.t('AREYOUSHURE'),
                  async btnAction()
                  {
                      me.showAnswersModal(item);
                  },
              });
          }
          else
          {
            me.showAnswersModal(item);
          }
          
      },
      showAnswersModal(item)
      {
        const me = this;
        if (typeof item == null)
          {
              item = {};
          }
          me.formAnswers = { ...item };
      },
      viewAnswersModal(item)
      {
          const me = this;
          
          me.$router.push(
              {
                  path: `/job/${item.jobId}/answers`,
              },
          );
      },
  },
    watch:
    {
        'paginationSec.date': function (newVal)
        {
            if (!newVal)
            {
                this.paginationSec.dateTo = null;
            }
        },
        pagination:
        {
            deep: true,
            handler()
            {
                const me = this;

                if (me.searchTimeout !== false)
                {
                    clearTimeout(me.searchTimeout);
                }

                me.searchTimeout = setTimeout(() =>
                {
                    me.getData();
                    me.searchTimeout = false;
                }, 300);
            },
        },
        paginationSec:
        {
            deep: true,
            handler()
            {
                const me = this;

                if (me.searchTimeout !== false)
                {
                    clearTimeout(me.searchTimeout);
                }

                me.searchTimeout = setTimeout(() =>
                {
                    me.pagination.currentPage = 1;
                    me.getData();
                    me.searchTimeout = false;
                }, 300);
            },
        },
    },
    computed:
  {
      ...mapGetters([
          'globals',
      ]),
      getParams()
      {
          const me = this;

          const data = { ...me.pagination, ...me.paginationSec };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
      getParamsBuilding()
      {
          const me = this;
          const data = { ...me.paginationBuilding };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
      getParamsSubCompany()
      {
          const me = this;
          const data = { ...me.paginationSubCompany };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
      getParamsCompany()
      {
          const me = this;
          const data = { ...me.paginationCompany };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
      paginValues()
        {
            const me = this;
            let totalCount = 0;
            if (me.data != null && me.data.totalCount != null)
             {
                 totalCount = me.data.totalCount;
             }
            return {
                start: (me.pagination.currentPage - 1) * me.pagination.limit,
                end: (me.pagination.currentPage * me.pagination.limit <totalCount)
                    ? me.pagination.currentPage * me.pagination.limit :totalCount,
            };
        },
  },
};
</script>